import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanErrorHandlerService } from '../../../core/services/plan-error-handler.service';
import { UpgradePlanDialogComponent } from '../upgrade-plan-dialog/upgrade-plan-dialog.component';

/**
 * Componente wrapper para mostrar el modal de upgrade globalmente.
 * Debe colocarse en AppComponent o en el layout principal.
 * 
 * Uso en app.component.ts:
 * 
 * imports: [GlobalUpgradeDialogComponent, ...]
 * 
 * Template:
 * <router-outlet></router-outlet>
 * <app-global-upgrade-dialog></app-global-upgrade-dialog>
 */
@Component({
  selector: 'app-global-upgrade-dialog',
  standalone: true,
  imports: [CommonModule, UpgradePlanDialogComponent],
  template: `
    <app-upgrade-plan-dialog
      [(visible)]="planErrorHandler.showUpgradeDialog"
      [data]="planErrorHandler.upgradeDialogData()"
      (upgrade)="onUpgrade()">
    </app-upgrade-plan-dialog>
  `
})
export class GlobalUpgradeDialogComponent {
  planErrorHandler = inject(PlanErrorHandlerService);

  onUpgrade() {
    // El modal ya navega a /configuracion
    // Aquí puedes agregar tracking o analytics si lo necesitas
  }
}